
import React, { useEffect, ReactNode } from 'react';

interface TelegramWebAppProviderProps {
  children: ReactNode;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export const TelegramWebAppProvider: React.FC<TelegramWebAppProviderProps> = ({
  children,
  onSubmit,
  isSubmitting
}) => {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg) {
      console.log('Initializing Telegram WebApp');
      tg.ready();
      tg.expand();
      
      // Apply Telegram theme
      if (tg.themeParams) {
        const root = document.documentElement;
        if (tg.themeParams.bg_color) {
          root.style.setProperty('--background', tg.themeParams.bg_color);
        }
        if (tg.themeParams.text_color) {
          root.style.setProperty('--foreground', tg.themeParams.text_color);
        }
        if (tg.themeParams.button_color) {
          root.style.setProperty('--primary', tg.themeParams.button_color);
        }
      }
      
      // Configure main button
      tg.MainButton.text = 'Submit Price Data';
      tg.MainButton.onClick(onSubmit);
      
      // Enable closing confirmation
      tg.enableClosingConfirmation();
    }

    return () => {
      const tg = window.Telegram?.WebApp;
      if (tg) {
        tg.MainButton.offClick(onSubmit);
        tg.disableClosingConfirmation();
      }
    };
  }, [onSubmit]);

  // Update button state based on submission status
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg) {
      if (isSubmitting) {
        tg.MainButton.text = 'Submitting...';
        tg.MainButton.disable();
        tg.disableClosingConfirmation();
      } else {
        tg.MainButton.text = 'Submit Price Data';
        tg.MainButton.enable();
        tg.enableClosingConfirmation();
      }
    }
  }, [isSubmitting]);

  return <>{children}</>;
};
